import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
import { Emission } from "./emissions";

const corporate = apiUrl + "/corporate";
const routes = {
  label: "Corporate",
  root: corporate,
  new: corporate + "/new",
  delete: corporate + "/delete",
  update: corporate + "/update",
  duplicate: corporate + "/duplicate",
  get_mine: corporate + "/get_mine",
  generate_insight_5_0: corporate + "/generate_insight_5_0",
  generate_insight_3_5: corporate + "/generate_insight_3_5",
  generate_insight_deepseek: corporate + "/generate_insight_deepseek",
  generate_insight_gemini_flash: corporate + "/generate_insight_gemini_flash",
  generate_insight_gemini_flash_lite: corporate + "/generate_insight_gemini_flash_lite",
  generate_insight_gemini_pro: corporate + "/generate_insight_gemini_pro",
  get_insight: corporate + "/get_insight",
};
export const Corporate = {
  get_mine: () => postWithToken(routes.get_mine),
  new: () => postWithToken(routes.new),
  update: (body) => postWithToken(routes.update, body),
  duplicate: (ids) => postWithToken(routes.duplicate, { ids }),
  delete: (ids) => postWithToken(routes.delete, { ids }),
  getEmissions: (id) => Emission.getEmissionsByCorpId({ id }),
  generate_insight_5_0: (id) => postWithToken(routes.generate_insight_5_0, { id }),
  generate_insight_3_5: (id) => postWithToken(routes.generate_insight_3_5, { id }),
  generate_insight_deepseek: (id) => postWithToken(routes.generate_insight_deepseek, { id }),
  generate_insight_gemini_flash: (id) => postWithToken(routes.generate_insight_gemini_flash, { id }),
  generate_insight_gemini_flash_lite: (id) => postWithToken(routes.generate_insight_gemini_flash_lite, { id }),
  generate_insight_gemini_pro: (id) => postWithToken(routes.generate_insight_gemini_pro, { id }),
  get_insight: (id) => postWithToken(routes.get_insight, { id }),
};
